var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-button',{attrs:{"type":"primary","disabled":!_vm.items.length},on:{"click":_vm.onMakePay}},[_vm._v("\n  Сформировать платежи на оплату\n")])}
var staticRenderFns = []

export { render, staticRenderFns }